import React from "react";
import style from "./index.module.scss";
import ListItem from "./components/ListItem";
import { EndExerciseQuestion } from "service/question";

interface TopicListProps {
    selectedIndex: number;
    questionList: EndExerciseQuestion[];
}

export default function TopicList({
    selectedIndex,
    questionList
}: TopicListProps) {
    return (
        <div className={style.root}>
            {questionList.map((question, index) => (
                <ListItem
                    key={question.id}
                    index={index}
                    data={question}
                    selected={selectedIndex === index}
                />
            ))}
        </div>
    );
}
